import {
  type ResultOf,
  type VariablesOf,
} from '@graphql-typed-document-node/core'
import { useMutation, type UseMutationOptions } from '@tanstack/react-query'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

const document = graphql(`
  mutation BrandAccountsListPage_CreateBrandAccount(
    $input: CreateBrandAccountInput!
  ) {
    createBrandAccount(input: $input) {
      id
    }
  }
`)
type Data = ResultOf<typeof document>
type Variables = VariablesOf<typeof document>

export const useCreateBrandAccountMutation = (
  options: Omit<
    UseMutationOptions<Data, unknown, Variables['input'], unknown>,
    'mutationFn'
  > = {},
) => {
  const graphQLRequest = useGraphQLRequest()

  return useMutation({
    mutationFn: (input) => graphQLRequest({ document, variables: { input } }),
    ...options,
  })
}
